import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import BackgroundBox from '../../components/custom_components/BackgroundBox'
import PerFlexRow from '../../components/custom_components/FlexRow'
import PerSpacer from '../../components/custom_components/Spacer'
import PerText from '../../components/custom_components/Text'
import { PerTag } from '../../components/custom_components/Tag'
import { SmartAvatar } from '../avatar/SmartAvatar'
import { FullMeetingFragment } from '../../types'

interface IOtherMeetingHeaderProps {
  meeting: FullMeetingFragment
  isPreparation: boolean
}

export const OtherMeetingHeader: FC<IOtherMeetingHeaderProps> = ({ meeting, isPreparation }) => {
  const { t } = useTranslation()

  return (
    <BackgroundBox color="transparent" noPadding r className="otherMeetings-header">
      <div data-e2e-other-meeting-header>
        <PerFlexRow justify="space-between">
          <BackgroundBox className="otherMeetings-header-left-box" noShadow>
            <SmartAvatar
              employeeId={meeting.employee.id}
              size="large"
              firstName={meeting.employee.chosenFirstName ? meeting.employee.chosenFirstName : meeting.employee.legalFirstName}
              lastName={meeting.employee.chosenLastName ? meeting.employee.chosenLastName : meeting.employee.legalLastName}
            />

            <PerSpacer ml="xxs">
              <PerText color="error" fontWeight="bold">
                {`${meeting.employee.chosenFirstName ? meeting.employee.chosenFirstName : meeting.employee.legalFirstName} ${
                  meeting.employee.chosenLastName ? meeting.employee.chosenLastName : meeting.employee.legalLastName
                }`}
              </PerText>

              <PerText fontSize="s" color="secondary">
                {meeting.employee.currentEmployeeLevel && t(`employee.contract.level.${meeting.employee.currentEmployeeLevel}`)}
              </PerText>

              <PerSpacer mt="xxxs">
                <PerTag color={isPreparation ? 'gold' : 'lime'} icon={isPreparation ? 'edit_fill' : 'chat_fill'}>
                  {isPreparation
                    ? t('appraisalMeeting.meetingStepper.status.preparation')
                    : t('appraisalMeeting.meetingStepper.status.meeting')}
                </PerTag>
              </PerSpacer>
            </PerSpacer>
          </BackgroundBox>

          <BackgroundBox className="otherMeetings-header-right-box" color="white75" noShadow>
            <PerText appearance="title" color="primary" fontSize="xxl">
              {t('otherMeetings.title')}
            </PerText>
          </BackgroundBox>
        </PerFlexRow>
      </div>
    </BackgroundBox>
  )
}
